import Vue from 'vue';
import store from '@/store';

Vue.directive('has', {
  inserted: (el, binding, vnode) => {
    // console.log("页面权限控制----");
    filterGlobalPermission(el, binding, vnode);
  }
});

/**
 * 全局权限控制
 */
export function filterGlobalPermission(el, binding, vnode) {
  // 设置全局配置是否有命中
  let invalidFlag = true;// 无效命中

  const perms = store.state.user.perms;
  for (const auth of perms.auth) {
    // console.log('auauth.type == ', auth);
    // 2 代表按钮权限
    if (auth.type == 1 && auth.action === binding.value) {
      invalidFlag = false;
    }
  }
  if (invalidFlag) {
    el.parentNode.removeChild(el);
  }
}



// WEBPACK FOOTER //
// ./src/directive/hasPermission.js